module.exports = __webpack_public_path__ + "static/img/img_keyboard.5752e12.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img_keyboard.png
// module id = kI5G
// module chunks = 0